import { FileType } from "@/Common/Models/FileType";
import { ExportableFile, IExportableFile, IExportableFileLoaded } from "../ExportableFile";

interface IFileTypeLab extends IExportableFile {
    LabfillerId: string;
}

class FileTypeLab extends ExportableFile implements IFileTypeLab {
    public LabfillerId: string;

    constructor(fields: IFileTypeLab) {
        super(FileType.LAB);
        Object.assign(this, fields);
    }

    public getAttachedObject_ObjectId(): string { return this.LabfillerId; }

    public getCleanCopy(): FileTypeLab {
        throw "Not implemented";
    }

    public async getMeta(): Promise<number> {
        throw "Not implemented";
    }

    protected generateFileIfNeeded(): Promise<IExportableFileLoaded> {
        throw "Not implemented"; // Print all EncapsulatedData of the Lab?? Mostly used as a shorcut to open th granular lab in myle for now
    }
}

export { FileTypeLab };
